/** @format */

if (document.querySelectorAll(".buy-now-form").length) {
  document.querySelectorAll(".buy-now-form").forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault()
      let formData = new FormData(this)

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      }).catch((error) => console.error("Error:", error))
    })
  })
}
